import {Component, Input} from '@angular/core';
import {DcpResourceData} from '@app/model/dcp-resource-data';

@Component({
  selector: 'dcp-product-tile-content',
  templateUrl: './product-tile-content.component.html',
  styleUrls: ['./product-tile-content.component.scss']
})
export class ProductTileContentComponent {

  @Input() imageTop: boolean = true;
  @Input() resource: DcpResourceData;

  get hasImage(): boolean {
    return !!this.resource && !!this.resource.source;
  }

  get hasLabel(): boolean {
    return !!this.resource && !!this.resource.label;
  }

  get hasDescription(): boolean {
    return !!this.resource && !!this.resource.description;
  }

  get headlineSize(): string {
    return (this.hasImage && this.hasDescription) ? 'xs' : 's';
  }
}
